import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HighRiskProvider } from "../../context/HighRiskContext";
import HighRiskPanel from "./HighRiskPanel";

const HighRiskPage = () => {
  const { t } = useTranslation();

  return (
    <HighRiskProvider>
      <Box sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
          {t("nav.highRisk", "High Risk")}
        </Typography>
        <HighRiskPanel />
      </Box>
    </HighRiskProvider>
  );
};

export default HighRiskPage;
